import React, { useMemo, useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DataTable, { Column } from '../table/DataTable';
import ReportActionsMenu from './ReportActionMenu';
import { Client } from '../../apis/tenantApi/tenantApi';
/*export interface Client {
  id: string;
  template: string;
  zone: string;
  tenantName: string;
  tenantSize: number;
  services: string[];
}*/

import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Fade from "@mui/material/Fade";
import { supersetReportsUrl } from "../../apis/postProvisionApi/postProvisionApi";

interface ReportListProps {
  tenants: Client[];
  loading?: boolean;
  onOpenReports?: (tenant: Client) => void;
}

const ReportsList: React.FC<ReportListProps> = ({ tenants, loading = false}) => {
  const navigate = useNavigate();

  const [alert, setAlert] = useState({
    open: false,
    message: "",
    severity: "info" as "success" | "error" | "info" | "warning",
  });

  const handleCloseAlert = () => {
    setAlert((prev) => ({ ...prev, open: false }));
  };

  const handleViewReports = useCallback(
    async (tenant: Client) => {
      try {
        const response: any = await supersetReportsUrl(
          tenant.clientId,
          tenant.clientName
        );

        if (!response) {
          setAlert({
            open: true,
            message:
              "This instance does not have the reporting module deployed or enabled.",
            severity: "error",
          });
          return;
        }

        navigate(
          `/Reports/iframe/${tenant.clientId}/${tenant.clientName}`
        );
      } catch (error) {
        console.error("Failed to load Superset URL", error);
      }
    },[navigate]
  );


  const columns: Column<Client>[] = useMemo(
    () => [
      { header: "Client Id", key: "clientId" },
      //{ header: "Template Id", key: "clientEnvConfigId" },
      { header: "Client Name", key: "clientName" },
      {
        header: "Actions",
        key: "clientId",
        render: (_: any, row: Client) => <ReportActionsMenu tenant={row} 
        onOpenReports={() => handleViewReports(row)}
        />,
      }
    ],
    [handleViewReports]
  );

  if (!Array.isArray(tenants)) {
    console.error(
      "Expected tenants to be an array, but received:",
      tenants
    );
    tenants = [];
  }

  return (
    <>
      <Snackbar
        open={alert.open}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        TransitionComponent={Fade}
      >
        <Alert
          onClose={handleCloseAlert}
          severity={alert.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alert.message}
        </Alert>
      </Snackbar>

      <DataTable columns={columns} data={tenants} loading={loading} />
    </>
  );
};

export default ReportsList;
